import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  reasonWrap: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  // Provenance line ("Overridden by …") shown once the limit is locked.
  note: {
    marginTop: theme.spacing(1),
    color: theme.colors?.text_secondary
  },
  // The "reach out to underwriting" lock warning rendered next to a locked limit field.
  lockWarning: {
    marginTop: theme.spacing(1),
    color: theme.colors?.error
  }
}));

export default useStyles;
